import { clearAttribution, getAttribution, publicPage } from './attribution';

const CONSENT_KEY = 'virgil_analytics_consent';
const ANONYMOUS_ID_KEY = 'virgil_analytics_id';
const CONSENT_EVENT = 'virgil:analytics-consent';

const EVENT_PROPERTIES = Object.freeze({
  public_page_viewed: ['page'],
  signup_started: [],
  auth_completed: [],
  beta_seat_reserved: ['plan'],
  beta_full: ['plan'],
  trial_checkout_started: ['plan'],
  trial_started: ['plan'],
  download_page_viewed: ['platform'],
  download_started: ['platform'],
});

export function getAnalyticsConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

export function setAnalyticsConsent(value) {
  if (value !== 'granted' && value !== 'denied') return;
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {}
  if (value === 'denied') {
    clearAttribution();
    try { localStorage.removeItem(ANONYMOUS_ID_KEY); } catch {}
  }
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
}

export function isAnalyticsConfigured() {
  return Boolean(process.env.REACT_APP_POSTHOG_KEY);
}

function getAnonymousId() {
  try {
    let value = localStorage.getItem(ANONYMOUS_ID_KEY);
    if (!value) {
      value =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(ANONYMOUS_ID_KEY, value);
    }
    return value;
  } catch {
    return `session-${Date.now()}`;
  }
}

function allowedProperties(event, properties) {
  const allowed = EVENT_PROPERTIES[event] || [];
  return allowed.reduce((result, key) => {
    const value = properties?.[key];
    if (typeof value === 'string' && value.length <= 32
      && (key !== 'page' || (publicPage(value) === value && value !== 'other'))) {
      result[key] = value;
    }
    return result;
  }, {});
}

export function capture(event, properties = {}) {
  const apiKey = process.env.REACT_APP_POSTHOG_KEY;
  if (
    !apiKey ||
    getAnalyticsConsent() !== 'granted' ||
    !Object.prototype.hasOwnProperty.call(EVENT_PROPERTIES, event)
  ) {
    return false;
  }

  const host = (
    process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com'
  ).replace(/\/+$/, '');
  const payload = {
    api_key: apiKey,
    event,
    properties: {
      distinct_id: getAnonymousId(),
      ...allowedProperties(event, properties),
      ...getAttribution(),
    },
    timestamp: new Date().toISOString(),
  };

  fetch(`${host}/capture/`, {
    method: 'POST',
    mode: 'cors',
    keepalive: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).catch(() => {});
  return true;
}

export { CONSENT_EVENT };
